/**
 * @generated SignedSource<<5131d8507d224d3767d394a209ce2aac>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type ProjectEmbedQuery$variables = {
  id: string;
  isSpecificUpdate: boolean;
  key: string;
};
export type ProjectEmbedQuery$data = {
  readonly projectByKey?: {
    readonly updates: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly " $fragmentSpreads": FragmentRefs<"ProjectEmbedUpdate">;
        } | null;
      } | null> | null;
    } | null;
    readonly workspace: {
      readonly uuid: string;
    };
    readonly " $fragmentSpreads": FragmentRefs<"ProjectEmbedAbout" | "ProjectEmbedRow">;
  } | null;
  readonly projectUpdate?: {
    readonly project: {
      readonly workspace: {
        readonly uuid: string;
      };
      readonly " $fragmentSpreads": FragmentRefs<"ProjectEmbedAbout" | "ProjectEmbedRow">;
    } | null;
    readonly " $fragmentSpreads": FragmentRefs<"ProjectEmbedUpdate">;
  } | null;
};
export type ProjectEmbedQuery = {
  response: ProjectEmbedQuery$data;
  variables: ProjectEmbedQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "id"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isSpecificUpdate"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "key"
},
v3 = [
  {
    "kind": "Variable",
    "name": "key",
    "variableName": "key"
  }
],
v4 = {
  "kind": "FragmentSpread",
  "name": "ProjectEmbedAbout"
},
v5 = {
  "kind": "FragmentSpread",
  "name": "ProjectEmbedRow"
},
v6 = {
  "kind": "ScalarField",
  "name": "uuid"
},
v7 = {
  "concreteType": "Workspace",
  "kind": "LinkedField",
  "name": "workspace",
  "plural": false,
  "selections": [
    (v6/*: any*/)
  ]
},
v8 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 1
  }
],
v9 = {
  "kind": "FragmentSpread",
  "name": "ProjectEmbedUpdate"
},
v10 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v11 = {
  "kind": "ScalarField",
  "name": "ari"
},
v12 = {
  "kind": "ScalarField",
  "name": "name"
},
v13 = {
  "kind": "ScalarField",
  "name": "picture"
},
v14 = {
  "kind": "ScalarField",
  "name": "accountId"
},
v15 = {
  "kind": "ScalarField",
  "name": "aaid"
},
v16 = {
  "kind": "ScalarField",
  "name": "id"
},
v17 = {
  "concreteType": "User",
  "kind": "LinkedField",
  "name": "owner",
  "plural": false,
  "selections": [
    {
      "concreteType": "UserPII",
      "kind": "LinkedField",
      "name": "pii",
      "plural": false,
      "selections": [
        (v12/*: any*/),
        (v13/*: any*/),
        {
          "kind": "ScalarField",
          "name": "accountStatus"
        },
        (v14/*: any*/)
      ]
    },
    (v15/*: any*/),
    (v16/*: any*/)
  ]
},
v18 = {
  "kind": "ScalarField",
  "name": "theMeasurement"
},
v19 = {
  "kind": "ScalarField",
  "name": "theWhat"
},
v20 = {
  "kind": "ScalarField",
  "name": "theWhy"
},
v21 = {
  "concreteType": "Workspace",
  "kind": "LinkedField",
  "name": "workspace",
  "plural": false,
  "selections": [
    (v6/*: any*/),
    (v16/*: any*/)
  ]
},
v22 = {
  "kind": "ScalarField",
  "name": "key"
},
v23 = {
  "kind": "ScalarField",
  "name": "private"
},
v24 = {
  "concreteType": "IconURIs",
  "kind": "LinkedField",
  "name": "iconUrl",
  "plural": false,
  "selections": [
    {
      "concreteType": "ThemeURIs",
      "kind": "LinkedField",
      "name": "square",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "light"
        },
        {
          "kind": "ScalarField",
          "name": "dark"
        },
        {
          "kind": "ScalarField",
          "name": "transparent"
        }
      ]
    }
  ]
},
v25 = {
  "kind": "ScalarField",
  "name": "label"
},
v26 = [
  {
    "kind": "ScalarField",
    "name": "messageId"
  }
],
v27 = {
  "concreteType": "LocalizationField",
  "kind": "LinkedField",
  "name": "localizedLabel",
  "plural": false,
  "selections": (v26/*: any*/)
},
v28 = {
  "kind": "ScalarField",
  "name": "value"
},
v29 = [
  (v25/*: any*/),
  (v27/*: any*/),
  (v28/*: any*/),
  {
    "concreteType": "CompletionProjectState",
    "kind": "LinkedField",
    "name": "atCompletionState",
    "plural": false,
    "selections": [
      (v28/*: any*/),
      (v25/*: any*/),
      (v27/*: any*/)
    ]
  }
],
v30 = {
  "concreteType": "ProjectState",
  "kind": "LinkedField",
  "name": "state",
  "plural": false,
  "selections": (v29/*: any*/)
},
v31 = [
  {
    "kind": "Literal",
    "name": "longFormat",
    "value": true
  }
],
v32 = [
  {
    "kind": "ScalarField",
    "name": "confidence"
  },
  (v25/*: any*/),
  (v27/*: any*/),
  {
    "alias": "tooltip",
    "args": (v31/*: any*/),
    "kind": "ScalarField",
    "name": "label",
    "storageKey": "label(longFormat:true)"
  },
  {
    "alias": "localizedTooltip",
    "args": (v31/*: any*/),
    "concreteType": "LocalizationField",
    "kind": "LinkedField",
    "name": "localizedLabel",
    "plural": false,
    "selections": (v26/*: any*/),
    "storageKey": "localizedLabel(longFormat:true)"
  },
  {
    "kind": "ScalarField",
    "name": "overdue"
  }
],
v33 = {
  "concreteType": "TargetDate",
  "kind": "LinkedField",
  "name": "dueDate",
  "plural": false,
  "selections": (v32/*: any*/)
},
v34 = {
  "kind": "ScalarField",
  "name": "summary"
},
v35 = {
  "kind": "ScalarField",
  "name": "missedUpdate"
},
v36 = {
  "kind": "ScalarField",
  "name": "updateType"
},
v37 = {
  "kind": "ScalarField",
  "name": "creationDate"
},
v38 = {
  "concreteType": "UserConnection",
  "kind": "LinkedField",
  "name": "members",
  "plural": false,
  "selections": [
    {
      "concreteType": "UserEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "concreteType": "User",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v15/*: any*/),
            (v16/*: any*/)
          ]
        }
      ]
    }
  ]
},
v39 = {
  "kind": "ScalarField",
  "name": "title"
},
v40 = {
  "concreteType": "UpdateNote",
  "kind": "LinkedField",
  "name": "notes",
  "plural": true,
  "selections": [
    (v6/*: any*/),
    {
      "kind": "ScalarField",
      "name": "archived"
    },
    (v39/*: any*/),
    (v34/*: any*/),
    (v16/*: any*/)
  ]
},
v41 = {
  "concreteType": "TargetDate",
  "kind": "LinkedField",
  "name": "oldDueDate",
  "plural": false,
  "selections": (v32/*: any*/)
},
v42 = {
  "concreteType": "TargetDate",
  "kind": "LinkedField",
  "name": "newDueDate",
  "plural": false,
  "selections": (v32/*: any*/)
},
v43 = {
  "alias": "newProjectState",
  "concreteType": "ProjectState",
  "kind": "LinkedField",
  "name": "newState",
  "plural": false,
  "selections": (v29/*: any*/)
},
v44 = {
  "alias": "oldProjectState",
  "concreteType": "ProjectState",
  "kind": "LinkedField",
  "name": "oldState",
  "plural": false,
  "selections": (v29/*: any*/)
},
v45 = [
  (v22/*: any*/),
  (v11/*: any*/),
  (v16/*: any*/)
],
v46 = [
  {
    "concreteType": "UserPII",
    "kind": "LinkedField",
    "name": "pii",
    "plural": false,
    "selections": [
      (v12/*: any*/),
      (v13/*: any*/),
      (v14/*: any*/)
    ]
  },
  (v15/*: any*/),
  (v16/*: any*/)
],
v47 = {
  "concreteType": "LearningConnection",
  "kind": "LinkedField",
  "name": "learnings",
  "plural": false,
  "selections": [
    {
      "concreteType": "LearningEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "concreteType": "Learning",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "type"
            },
            (v6/*: any*/),
            (v16/*: any*/),
            (v34/*: any*/),
            {
              "kind": "ScalarField",
              "name": "description"
            },
            {
              "kind": "InlineFragment",
              "selections": [
                (v11/*: any*/),
                {
                  "concreteType": "Project",
                  "kind": "LinkedField",
                  "name": "project",
                  "plural": false,
                  "selections": (v45/*: any*/)
                },
                {
                  "concreteType": "Goal",
                  "kind": "LinkedField",
                  "name": "goal",
                  "plural": false,
                  "selections": (v45/*: any*/)
                },
                {
                  "concreteType": "User",
                  "kind": "LinkedField",
                  "name": "creator",
                  "plural": false,
                  "selections": (v46/*: any*/)
                },
                (v37/*: any*/),
                {
                  "concreteType": "User",
                  "kind": "LinkedField",
                  "name": "lastEditedBy",
                  "plural": false,
                  "selections": (v46/*: any*/)
                },
                {
                  "kind": "ScalarField",
                  "name": "lastEditedDate"
                }
              ],
              "type": "Highlight",
              "abstractKey": "__isHighlight"
            }
          ]
        }
      ]
    }
  ]
},
v48 = {
  "concreteType": "MilestoneConnection",
  "kind": "LinkedField",
  "name": "milestones",
  "plural": false,
  "selections": [
    {
      "concreteType": "MilestoneEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "concreteType": "Milestone",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v6/*: any*/),
            (v16/*: any*/),
            (v39/*: any*/),
            {
              "kind": "ScalarField",
              "name": "targetDate"
            },
            {
              "kind": "ScalarField",
              "name": "targetDateType"
            },
            {
              "kind": "ScalarField",
              "name": "status"
            }
          ]
        }
      ]
    }
  ]
},
v49 = {
  "kind": "ScalarField",
  "name": "newTargetDate"
},
v50 = {
  "concreteType": "ProjectChangelogItem",
  "kind": "LinkedField",
  "name": "changelog",
  "plural": true,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "newValue"
    },
    {
      "kind": "ScalarField",
      "name": "oldValue"
    },
    (v16/*: any*/)
  ]
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "name": "ProjectEmbedQuery",
    "selections": [
      {
        "condition": "isSpecificUpdate",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "args": (v3/*: any*/),
            "concreteType": "Project",
            "kind": "LinkedField",
            "name": "projectByKey",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              (v5/*: any*/),
              (v7/*: any*/),
              {
                "args": (v8/*: any*/),
                "concreteType": "ProjectUpdateConnection",
                "kind": "LinkedField",
                "name": "updates",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "ProjectUpdateEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "ProjectUpdate",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v9/*: any*/)
                        ]
                      }
                    ]
                  }
                ],
                "storageKey": "updates(first:1)"
              }
            ]
          }
        ]
      },
      {
        "condition": "isSpecificUpdate",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": (v10/*: any*/),
            "concreteType": "ProjectUpdate",
            "kind": "LinkedField",
            "name": "projectUpdate",
            "plural": false,
            "selections": [
              {
                "concreteType": "Project",
                "kind": "LinkedField",
                "name": "project",
                "plural": false,
                "selections": [
                  (v7/*: any*/),
                  (v4/*: any*/),
                  (v5/*: any*/)
                ]
              },
              (v9/*: any*/)
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "ProjectEmbedQuery",
    "selections": [
      {
        "condition": "isSpecificUpdate",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "args": (v3/*: any*/),
            "concreteType": "Project",
            "kind": "LinkedField",
            "name": "projectByKey",
            "plural": false,
            "selections": [
              (v11/*: any*/),
              (v17/*: any*/),
              (v18/*: any*/),
              (v19/*: any*/),
              (v20/*: any*/),
              (v6/*: any*/),
              (v21/*: any*/),
              (v22/*: any*/),
              (v16/*: any*/),
              (v12/*: any*/),
              (v23/*: any*/),
              (v24/*: any*/),
              (v30/*: any*/),
              (v33/*: any*/),
              {
                "args": (v8/*: any*/),
                "concreteType": "ProjectUpdateConnection",
                "kind": "LinkedField",
                "name": "updates",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "ProjectUpdateEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "ProjectUpdate",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v6/*: any*/),
                          (v34/*: any*/),
                          (v35/*: any*/),
                          (v36/*: any*/),
                          (v37/*: any*/),
                          {
                            "concreteType": "Project",
                            "kind": "LinkedField",
                            "name": "project",
                            "plural": false,
                            "selections": [
                              (v22/*: any*/),
                              (v6/*: any*/),
                              (v11/*: any*/),
                              (v38/*: any*/),
                              (v21/*: any*/),
                              (v16/*: any*/)
                            ]
                          },
                          (v40/*: any*/),
                          (v41/*: any*/),
                          (v42/*: any*/),
                          (v43/*: any*/),
                          (v44/*: any*/),
                          (v47/*: any*/),
                          (v48/*: any*/),
                          (v49/*: any*/),
                          (v50/*: any*/),
                          (v16/*: any*/)
                        ]
                      }
                    ]
                  }
                ],
                "storageKey": "updates(first:1)"
              }
            ]
          }
        ]
      },
      {
        "condition": "isSpecificUpdate",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": (v10/*: any*/),
            "concreteType": "ProjectUpdate",
            "kind": "LinkedField",
            "name": "projectUpdate",
            "plural": false,
            "selections": [
              {
                "concreteType": "Project",
                "kind": "LinkedField",
                "name": "project",
                "plural": false,
                "selections": [
                  (v21/*: any*/),
                  (v11/*: any*/),
                  (v17/*: any*/),
                  (v18/*: any*/),
                  (v19/*: any*/),
                  (v20/*: any*/),
                  (v6/*: any*/),
                  (v22/*: any*/),
                  (v16/*: any*/),
                  (v12/*: any*/),
                  (v23/*: any*/),
                  (v24/*: any*/),
                  (v30/*: any*/),
                  (v33/*: any*/),
                  (v38/*: any*/)
                ]
              },
              (v6/*: any*/),
              (v34/*: any*/),
              (v35/*: any*/),
              (v36/*: any*/),
              (v37/*: any*/),
              (v40/*: any*/),
              (v41/*: any*/),
              (v42/*: any*/),
              (v43/*: any*/),
              (v44/*: any*/),
              (v47/*: any*/),
              (v48/*: any*/),
              (v49/*: any*/),
              (v50/*: any*/),
              (v16/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "45aceefc9768e376de861e9fccba1621",
    "id": null,
    "metadata": {},
    "name": "ProjectEmbedQuery",
    "operationKind": "query",
    "text": "query ProjectEmbedQuery(\n  $key: String!\n  $id: ID!\n  $isSpecificUpdate: Boolean!\n) {\n  projectByKey(key: $key) @skip(if: $isSpecificUpdate) {\n    ...ProjectEmbedAbout\n    ...ProjectEmbedRow\n    workspace {\n      uuid\n      id\n    }\n    updates(first: 1) {\n      edges {\n        node {\n          ...ProjectEmbedUpdate\n          id\n        }\n      }\n    }\n    id\n  }\n  projectUpdate(id: $id) @include(if: $isSpecificUpdate) {\n    project {\n      workspace {\n        uuid\n        id\n      }\n      ...ProjectEmbedAbout\n      ...ProjectEmbedRow\n      id\n    }\n    ...ProjectEmbedUpdate\n    id\n  }\n}\n\nfragment LearningCard_cardQuery on Learning {\n  uuid\n  id\n  summary\n  description\n  type\n  ...LearningModifierSignatures_data\n}\n\nfragment LearningModifierSignatures_data on Highlight {\n  __isHighlight: __typename\n  uuid\n  ari\n  project {\n    key\n    ari\n    id\n  }\n  goal {\n    key\n    ari\n    id\n  }\n  creator {\n    pii {\n      name\n    }\n    ...UserAvatar_2aqwkz\n    id\n  }\n  creationDate\n  lastEditedBy {\n    pii {\n      name\n    }\n    ...UserAvatar_2aqwkz\n    id\n  }\n  lastEditedDate\n}\n\nfragment LearningsSummary_data on ProjectUpdate {\n  learnings {\n    edges {\n      node {\n        type\n        ...LearningCard_cardQuery\n        id\n      }\n    }\n  }\n}\n\nfragment MilestoneCard_cardQuery on Milestone {\n  uuid\n  ...MilestoneFields\n}\n\nfragment MilestoneFields on Milestone {\n  id\n  title\n  targetDate\n  targetDateType\n  status\n}\n\nfragment MilestonesSummary_data on ProjectUpdate {\n  milestones {\n    edges {\n      node {\n        ...MilestoneCard_cardQuery\n        id\n      }\n    }\n  }\n}\n\nfragment MissingDetailsPrompt on Project {\n  owner {\n    pii {\n      name\n    }\n    aaid\n    id\n  }\n  key\n  theMeasurement\n  theWhat\n  theWhy\n}\n\nfragment ProjectDateChanged on ProjectUpdate {\n  oldDueDate {\n    ...TargetDate\n  }\n  newDueDate {\n    ...TargetDate\n  }\n}\n\nfragment ProjectEmbedAbout on Project {\n  ari\n  owner {\n    pii {\n      name\n    }\n    aaid\n    id\n  }\n  theMeasurement\n  theWhat\n  theWhy\n  uuid\n  workspace {\n    uuid\n    id\n  }\n  ...MissingDetailsPrompt\n}\n\nfragment ProjectEmbedRow on Project {\n  ...ProjectName_data\n  owner {\n    ...UserAvatar_1cDMtx\n    id\n  }\n  state {\n    ...ProjectState\n  }\n  dueDate {\n    ...TargetDate\n  }\n}\n\nfragment ProjectEmbedUpdate on ProjectUpdate {\n  uuid\n  summary\n  missedUpdate\n  updateType\n  creationDate\n  project {\n    key\n    uuid\n    ari\n    members {\n      ...utils_isUserInList\n    }\n    workspace {\n      uuid\n      id\n    }\n    id\n  }\n  ...ProjectUpdateCardContentExtras\n}\n\nfragment ProjectIcon on Project {\n  private\n  iconUrl {\n    square {\n      light\n      dark\n      transparent\n    }\n  }\n}\n\nfragment ProjectName_data on Project {\n  id\n  key\n  name\n  uuid\n  ...ProjectIcon\n}\n\nfragment ProjectState on ProjectState {\n  label\n  localizedLabel {\n    messageId\n  }\n  value\n  atCompletionState {\n    value\n    label\n    localizedLabel {\n      messageId\n    }\n  }\n}\n\nfragment ProjectStatusChanged on ProjectUpdate {\n  newProjectState: newState {\n    ...ProjectState\n  }\n  oldProjectState: oldState {\n    ...ProjectState\n  }\n}\n\nfragment ProjectUpdateCardContentExtras on ProjectUpdate {\n  ...ProjectUpdateNotes\n  ...ProjectUpdateDiff\n  ...LearningsSummary_data\n  ...MilestonesSummary_data\n  ...ProjectUpdateTargetDateAutoUpdated\n}\n\nfragment ProjectUpdateDiff on ProjectUpdate {\n  ...ProjectDateChanged\n  ...ProjectStatusChanged\n}\n\nfragment ProjectUpdateNotes on ProjectUpdate {\n  notes {\n    uuid\n    ...UpdateNote\n    id\n  }\n}\n\nfragment ProjectUpdateTargetDateAutoUpdated on ProjectUpdate {\n  project {\n    key\n    id\n  }\n  newTargetDate\n  changelog {\n    newValue\n    oldValue\n    id\n  }\n}\n\nfragment TargetDate on TargetDate {\n  confidence\n  label\n  localizedLabel {\n    messageId\n  }\n  tooltip: label(longFormat: true)\n  localizedTooltip: localizedLabel(longFormat: true) {\n    messageId\n  }\n  overdue\n}\n\nfragment UpdateNote on UpdateNote {\n  archived\n  uuid\n  title\n  summary\n}\n\nfragment UserAvatar_1cDMtx on User {\n  aaid\n  pii {\n    picture\n    name\n    accountStatus\n    accountId\n  }\n}\n\nfragment UserAvatar_2aqwkz on User {\n  aaid\n  pii {\n    picture\n    accountId\n  }\n}\n\nfragment utils_isUserInList on UserConnection {\n  edges {\n    node {\n      aaid\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "5c0ec8da7bc2b2fa6b1938f9bb5bf704";

export default node;
